exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".specialAttributeCard__container___1mtj7 {\n  margin: 0 15px;\n  flex: 1;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  border-top: 1px solid #F4F4F4;\n  padding: 15px 0; }\n  .specialAttributeCard__container___1mtj7 .specialAttributeCard__icon___1jhkj {\n    height: 29px;\n    width: auto; }\n", ""]);

// exports
exports.locals = {
	"container": "specialAttributeCard__container___1mtj7",
	"icon": "specialAttributeCard__icon___1jhkj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/SpecialSectionMobile/SpecialAttributeCard/specialAttributeCard.scss
// module id = 4415
// module chunks = 6